'use strict';

var self = module.exports = {

  /************************************************************************************************************************
   * Init
   /***********************************************************************************************************************/

  init: function() {

    /************************************************************************************************************************
     * Inizializza la gallery
     /***********************************************************************************************************************/

    /**
     * Inizializza la gallery con i colori di sfondo
     *
     * @plugin
     */
    $('.gallery-colors__carousel').owlCarousel({
      dots: false,
      loop: true,
      nav: true,
      navContainer: '.gallery-colors__nav',
      navElement: 'div class="gallery-colors__controls carousel__controls"',
      navText: false,
      responsive: {
        0: {
          items: 3,
          slideBy: 3
        },
        375: {
          items: 4,
          slideBy: 4
        },
        768: {
          items: 5,
          slideBy: 5
        }
      }
    });

    /************************************************************************************************************************
     * Mostra la gallery con i colori di sfondo
     /***********************************************************************************************************************/

    $('[data-js="canvas-options"]').click(function() {
      self.toggle($('.canvas__options'), $(this));
    });

    $('[data-js="btn-color"]').click(function() {
      var $button = $(this),
        $color = $button.css('background-color');

      $('.canvas').css('background-color', $color);
      self.close($('.canvas__options'), $('[data-js="canvas-options"]'));
    });

    /************************************************************************************************************************
     * Porta il canvas allo stato iniziale
     /***********************************************************************************************************************/

    $('[data-js="canvas-reset-confirm"]').click(function() {
      $(document).find('.editor__canvas').attr('data-modified', 0);
      $(document).find('.editor__canvas').attr('data-parent', '');
      $('#modal-delete-confirm').foundation('open');
    });

    $('[data-js="canvas-reset"]').click(function() {
      self.reset();
    });

    /************************************************************************************************************************
     * Mostra la modal con le istruzioni
     /***********************************************************************************************************************/

    $('[data-js="modal-help"]').on('open.zf.reveal', function() {
      var $modal = $(this);

      $modal
        .find('.instructions')
        .addClass('instructions_animation_start');
    });

    $('[data-js="modal-help"]').on('closed.zf.reveal', function() {
      var $modal = $(this);

      $modal
        .find('.instructions')
        .removeClass('instructions_animation_start');
    });

    /************************************************************************************************************************
     * Disabilita la selezione
     /***********************************************************************************************************************/

    $('[data-js="canvas-touch"]').click(function() {
      $('.canvas')
        .find('.draggable')
        .removeClass('draggable_selected');

      self.close($('.canvas__footer'));
      self.close($('.canvas__options'), $('[data-js="canvas-options"]'));
    });
  },

  /************************************************************************************************************************
   * Reset
   /***********************************************************************************************************************/

  reset: function() {
    var $canvas = $('.canvas'),
      $canvasWidth = $canvas.width(),
      $canvasHeight = $canvas.height(),
      $cabbage = $canvas.find('.draggable_theme_cabbage'),
      $cabbageWidth = $cabbage.width(),
      $cabbageHeight = $cabbage.height();

    $cabbage
      .css({
        top: Math.round(((($canvasHeight - $cabbageHeight) / 2) * 100) / $canvasHeight) + '%',
        left: Math.round(((($canvasWidth - $cabbageWidth) / 2) * 100) / $canvasWidth) + '%'
      })
      .removeClass('draggable_selected')
      .find('.draggable__item')
      .data('flipX', global.flipValueDefault)
      .data('flipY', global.flipValueDefault)
      .data('isCabbage', true)
      .data('rotate', global.rotationValueDefault)
      .removeAttr('style');

    $('.canvas')
      .css('background-color', '#ffffff')
      .find('.draggable_theme_all')
      .remove();

    self.close($('.canvas__footer'));
    self.close($('.canvas__options'), $('[data-js="canvas-options"]'));
  },

  /************************************************************************************************************************
   * Toggle
   /***********************************************************************************************************************/

  toggle: function(element, button) {

    if(element.hasClass('close')) {
      self.open(element, button);
    } else {
      self.close(element, button);
    }
  },

  open: function(element, button) {

    if(button != null) {
      button
        .addClass('active');
    }

    element
      .removeClass('close')
      .addClass('open');
  },

  close: function(element, button) {

    if(button != null) {
      button
        .removeClass('active');
    }

    element
      .removeClass('open')
      .addClass('close');
  }
}

self.init();
